<script>
import DocumentListComponent from "./components/resources/DocumentListComponent.vue";
import AutoriryComponent from "./components/resources/AutoriryComponent.vue";
import NewsComponent from "./components/resources/NewsComponent.vue";
import ITCGridComponent from "./components/resources/ITCGridComponent.vue";
import BoxIconGridComponent from "./components/resources/BoxIconGridComponent.vue";
import MultiSliderComponent from "./components/resources/MultiSliderComponent.vue";
import FrecuentAccessComponent from "./components/resources/FrecuentAccessComponent.vue";
import GridLinkComponent from "./components/resources/GridLinkComponent.vue";
import CardGridComponent from "./components/resources/CardGridComponent.vue";
export default {
  name: "HomeView",
  components: {
    /* eslint-disable */
    DocumentListComponent,
    /* eslint-disable */
    AutoriryComponent,
    /* eslint-disable */
    NewsComponent,
    /* eslint-disable */
    ITCGridComponent,
    /* eslint-disable */
    BoxIconGridComponent,
    /* eslint-disable */
    MultiSliderComponent,
    /* eslint-disable */
    FrecuentAccessComponent,
    /* eslint-disable */
    GridLinkComponent,
    /* eslint-disable */
    CardGridComponent,
  },
  data() {
    return {
      site: 29,
    };
  },
  mounted() {
    document.title = process.env.VUE_APP_TITLE;
  },
};
</script>

<template>
  <!-- seccion info institucional conectividad -->
  <section>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2>Subdirección de Conectividad</h2> <br>
          <h3 class="link-secondary text-ptn-color-gsj-5">Visión:</h3>
          <p>
            La Dirección de Redes y Centro de Datos tiene como visión incorporar
            tecnologías de Telecomunicaciones de última generación para los
            organismos de todo el Poder Ejecutivo de San Juan, para proveer la
            plataforma de conectividad de las herramientas tecnológicas que
            mejoren las prestaciones de servicios y productos requeridos por la
            ciudadanía.
          </p>
          <h3 class="link-secondary text-ptn-color-gsj-5">Misión:</h3>
          <p class="pb-3">
            Entender en todo lo que compete a la Administracion de las
            Telecomunicaciones en el ámbito provincial. Definir las Políticas de
            Telecomunicaciones. Asegurar los servicios de telefonía fija y
            móvil, redes de voz y datos, enlaces de Fibra Óptica, Radio,
            Satelital, redes LAN, WAN y Datacenter.
          </p>
          <h3 class="link-secondary text-ptn-color-gsj-5">Servicios:</h3>
          <p class="pb-3">
            Conectividad al Datacenter de Gobierno para acceso a los servidores
            y aplicaciones, que brindan servicios a los ciudadanos y agentes de
            la Administración Pública Provincial. Conectividad de Acceso a
            Internet. Servicio de Telefonía fija y gestión de telefonía móvil.
          </p>
          <h3 class="link-secondary text-ptn-color-gsj-5">
            Redes y Conectividad:
          </h3>
          <p class="pb-3">
            Las redes están formadas por los equipamientos de telecomunicaciones
            que conectan un usuario de una red de gobierno, con el Datacenter e
            internet y, la conectividad, es la vinculación física y lógica de
            esos elementos.
          </p>
          <h3 class="link-secondary text-ptn-color-gsj-5">Data center:</h3>
          <p class="pb-3">
            Infraestructura de espacio para alojamiento de Servidores y equipos
            de Telecomunicaciones, con Energía Segurizada, Temperatura
            Controlada, Sistema Anti-Incendio y Seguridad Física y Lógica.
          </p>
        </div>
      </div>
    </div>
    <BoxIconGridComponent :columnas="3" titulo="Servicios" :data="[
      {
        desc: null,
        icon: 'ptn-i-documento',
        target: '_blank',
        title: 'Descarga de Formularios',
        url: 'https://web.sanjuan.gob.ar/formulariostic/',
      },
    ]" />
  </section>


  <!----Fin sección institucional conectividad---->

  <!-- seccion info institucional Ciberseguridad-->
  <section>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="pb-3">Subdirección de Ciberseguridad</h2>
          <p class="pb-3">
            También conocida como seguridad de las tecnologías de la
            información, es la rama de la informática que procura detectar
            vulnerabilidades que ponen en juego la integridad, disponibilidad y
            confidencialidad de los sistemas informáticos.
          </p>
          <p>
            Desde la Dirección de Ciberseguridad diseñando políticas que brindan
            protección informática, a través de la prevención, detención,
            respuesta y recupero ante incidentes de seguridad informática del
            Gobierno de la Provincia de San Juan.
          </p>
        </div>
      </div>
    </div>
  </section>

  <CardGridComponent titulo="Pilares" :data="[
    {
      target: '_self',
      title: 'Gestión de Incidentes',
      url: 'https://reportevulnerabilidad.sanjuan.gob.ar/',
    },
    {
      target: '_blank',
      title: 'Concientización',
      url: 'https://www.youtube.com/@CiberseguridadSanJuan',
    },
    // {
    //   target: '_self',
    //   title: 'Políticas',
    //   url: '?uid=politicas',
    // },
  ]" columnas="2" />

  <BoxIconGridComponent :columnas="4" titulo="Servicios y Trámites" :data="[
    {
      desc: null,
      icon: 'ptn-i-seguridad',
      target: '_self',
      title: 'Test para identificar Pishing',
      url: 'https://phishingquiz.withgoogle.com/',
    },
    // {
    //   desc: null,
    //   icon: 'ptn-i-centro-civ',
    //   target: '_self',
    //   title: 'Sistemas',
    //   url: '?uid=AS1UFMA9V6',
    // },
    // {
    //   desc: null,
    //   icon: 'ptn-i-documento',
    //   target: '_self',
    //   title: 'Catálogo de Aplicaciones y Servicios',
    //   url: '?uid=3K42LTGU6Z',
    // },
    {
      desc: null,
      icon: 'ptn-i-hacienda-f',
      target: '_self',
      title: 'Trámite Sueldos',
      url: 'https://mi.sanjuan.gob.ar/',
    },
    {
      desc: null,
      icon: 'ptn-i-centro-civ',
      target: '_self',
      title: 'Formulario 101',
      url: 'https://mi.sanjuan.gob.ar/',
    },
    {
      desc: null,
      icon: 'ptn-i-des-hum-pro-s',
      target: '_self',
      title: 'Solicitud de Intervención técnica',
      url: 'https://mi.sanjuan.gob.ar/',
    },
  ]" />

  <ITCGridComponent :columnas="2" titulo="" :data="[
    {
      desc: 'Ofrecemos soluciones para identificar, proteger, detectar y resolver incidentes de seguridad informática.',
      icon: 'ptn-i-candado',
      target: null,
      title: 'Qué hacemos',
      url: null,
    },
    {
      desc: 'Catálogo de Servicios provistos para realizar integraciones de sistemas e intercambio de información en diferentes reparticiones.',
      icon: 'ptn-i-documento',
      target: '_blank',
      title: 'Servicios',
      url: 'https://web.sanjuan.gob.ar/formulariostic/#CIBERSEGURIDAD',
    },
    // {
    //   desc: 'Construir un ámbito digital seguro dentro de la administración pública protegiendo los datos críticos que administra.',
    //   icon: 'ptn-i-ag-calidad-sj',
    //   target: null,
    //   title: 'Visión',
    //   url: null,
    // },
  ]" />
  <!----Fin sección institucional Ciberseguridad---->

  <ITCGridComponent :columnas="4" titulo="Consultas y Trámites" :data="[
    {
      desc: null,
      icon: 'ptn-i-documento',
      target: '_self',
      title: 'Consulta de Expedientes',
      url: '?uid=CUMV-VIEW-ExpedientesComponent',
    },
    {
      desc: null,
      icon: 'ptn-i-acuerdo',
      target: '_self',
      title: 'Contrataciones',
      url: 'https://compraspublicas.sanjuan.gob.ar/',
    },
    {
      desc: null,
      icon: 'note',
      target: '_self',
      title: 'Trámites',
      url: 'https://tramite.sanjuan.gob.ar/principal/listar',
    },
    {
      desc: null,
      icon: 'forum',
      target: '_self',
      title: 'Consultas y Solicitudes',
      url: '?uid=CUMV-VIEW-ExpedientesComponent',
    },
  ]" />

  <NewsComponent />


  <GridLinkComponent :columnas="4" titulo="Links Útiles" :data="[
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Ministerio de Economía, Hacienda y Finanzas',
      url: 'https://hacienda.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Secretaría de Transformación Digital y Modernización del Estado',
      url: 'https://secretaria.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Dirección de Gobierno Digital',
      url: 'https://dga.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Ciudadano Digital',
      url: 'https://cidi.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title:
        'Dirección de Recursos Humanos y Organización del Empleo Público',
      url: 'https://rrhh.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'IIEE - Instituto de Investigaciones Económicas y Estadísticas',
      url: 'https://web.sanjuan.gob.ar/iiee/',
    },
    {
      subtitle: 'Página Web',
      target: '_blank',
      title: 'Dirección Provincial de Informática',
      url: 'https://dpi.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Innova',
      url: 'http://innova.sanjuan.gob.ar/',
    },
    {
      subtitle: 'Página web',
      target: '_blank',
      title: 'Compras Públicas',
      url: 'https://compraspublicas.sanjuan.gob.ar/',
    },
  ]" />

  <!--  
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <DocumentListComponent
          resultados="5"
          :show-fecha="false"
          titulo="Guía de Trámites"
          :filtros="{ site: this.site }"
        />
      </div>
      <div class="col-md-6">
        <DocumentListComponent
          resultados="5"
          :show-fecha="true"
          titulo="Licitaciones"
          :filtros="{ site: 4 }"
        />
      </div>
    </div>
  </div>
-->
</template>
